import React from 'react'

const Offers = ({cafeid}) => {
  return (
    <div>
      
    Offers
    Give offers and discounts to your customers to attract more business and increase customer loyalty. You can create various types of offers such as percentage discounts, flat discounts, buy-one-get-one (BOGO) deals, and more. These offers can be applied to specific menu items, categories, or the entire order. By strategically using offers, you can boost sales during off-peak hours, promote new menu items, and reward loyal customers.
  
        
    </div>
  )
}

export default Offers